import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import HomePopup from '../../components/Home/Popup';

import './style.scss';

var data = require('./data.json');

export default class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            emailValid: true,
            popup: false,
        };
    }
    handleInput = e => {
        this.setState({
            email: e.target.value,
        });
    };
    handleSubmit = e => {
        e.preventDefault();
        // Check email address
        if (/^[a-zA-Z0-9.+]+@[a-zA-Z0-9]+\.[A-Za-z.]+$/.test(this.state.email)) {
            localStorage.removeItem('popup');
            this.setState({ popup: true });
            this.setState({ emailValid: true });
        } else {
            this.setState({ emailValid: false });
        }
    };
    render() {
        return (
            <footer>
                {this.state.popup ? <HomePopup step="2" email={this.state.email} /> : null}
                <div className="signup">
                    <form>
                        <input
                            type="email"
                            required
                            placeholder="Sign up for Regulatory News Alerts &amp; Announcements"
                            onChange={e => this.handleInput(e)}
                            value={this.state.email}
                            className={this.state.emailValid ? null : 'invalid'}
                        />
                        <input
                            type="submit"
                            value="Submit"
                            onClick={e => this.handleSubmit(e)}
                            disabled={this.state.email.length === 0}
                        />
                        {this.state.emailValid ? null : (
                            <p className="error">Please enter a valid email address.</p>
                        )}
                    </form>
                </div>
                <div className="container">
                    <ul>
                        {data.items.map((item, key) => {
                            return (
                                <li key={key}>
                                    {data.items[key].sub ? (
                                        item.text
                                    ) : (
                                        <Link to={item.url}>{item.text}</Link>
                                    )}
                                    {data.items[key].sub &&
                                        data.items[key].sub.map((sub, key) => {
                                            return (
                                                <span key={key}>
                                                    <Link to={sub.url}>{sub.text}</Link>
                                                </span>
                                            );
                                        })}
                                </li>
                            );
                        })}
                    </ul>
                    <ul>
                        <li>
                            {data.socials.map((item, key) => {
                                return (
                                    <a
                                        key={key}
                                        href={item.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <span className={item.name} />
                                    </a>
                                );
                            })}
                        </li>
                        <li>
                            {data.right.map((item, key) => {
                                return (
                                    <span key={key}>
                                        <Link to={item.url}>{item.text}</Link>
                                        <span className="divider">|</span>
                                    </span>
                                );
                            })}
                            <br />
                            Copyright &copy; 2019 JD Sports Fashion Plc. All rights reserved.
                        </li>
                    </ul>
                </div>
            </footer>
        );
    }
}
